"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _TopicListItemView = _interopRequireDefault(require("../topic-list-view/TopicListItemView.sync"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FeaturedTopicsListAsSearchResults = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FeaturedTopicsListAsSearchResults, _Component);

  var _super = _createSuper(FeaturedTopicsListAsSearchResults);

  function FeaturedTopicsListAsSearchResults(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FeaturedTopicsListAsSearchResults);
    _this = _super.call(this, props);
    _this.state = {
      topics: [],
      error: false
    };
    return _this;
  }

  (0, _createClass2.default)(FeaturedTopicsListAsSearchResults, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadTopics();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "loadTopics",
    value: function () {
      var _loadTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  error: false
                });
                _context2.prev = 1;
                _context2.next = 4;
                return _axios.default.get("/events/".concat(this.props.eventId, "/featuredTopics"));

              case 4:
                res = _context2.sent;
                this.setState({
                  topics: res.data
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  error: true
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function loadTopics() {
        return _loadTopics.apply(this, arguments);
      }

      return loadTopics;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var attachmentCdn = this.props.attachmentCdn;
      var _this$state = this.state,
          error = _this$state.error,
          topics = _this$state.topics;

      if (error) {
        return (0, _preact.h)("div", {
          className: "event-featured-topics-error-container",
          id: "featured-topics"
        }, "Something went wrong, we have troubles displaying topics. Please ", (0, _preact.h)("a", {
          href: "#featured-topics",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this2.loadTopics();

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))
        }, "try again"), ".");
      }

      if (topics.length === 0) return null;
      return (0, _preact.h)("div", {
        className: "event-featured-topics-container"
      }, (0, _preact.h)("div", {
        className: "event-attendees__header_label"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.featured.topics"
      })), topics.map(function (topic, index) {
        return (0, _preact.h)(_TopicListItemView.default, {
          key: index,
          hideCategoryMetadata: false,
          topic: topic,
          attachmentCdn: attachmentCdn,
          clickCallback: function clickCallback() {}
        });
      }));
    }
  }]);
  return FeaturedTopicsListAsSearchResults;
}(_preact.Component);

var _default = FeaturedTopicsListAsSearchResults;
exports.default = _default;